export const TOP_NAV_ITEMS = [
  { text: 'Item A', href: '/' },
  { text: 'Item B', href: '/' },
  { text: 'Item C', href: '/' },
  { text: 'Item D', href: '/' },
]
